export default "__VITE_ASSET__0347ca70__"